export default __webpack_public_path__ + "static/media/pattern-quotes.219bd182.svg";